module.exports = __webpack_public_path__ + "img/icon-auth-logout.df6250c4.svg";